import "./Home.module.css";
import PrintTeeMainHeader from "@/reusable_sections/Header";
import SurgicalCategoryBanner from "./sections/SurgicalCategoryBanner";
import InvestorTrustCertification from "./sections/InvestorTrustCertification";
import FeaturedResearchPeptides from "./sections/FeaturedResearchPeptides";
import WhyChooseFreshness from "./sections/WhyChooseFreshness";
import JoinTheGrowerCircle from "./sections/JoinTheGrowerCircle";
import ComplianceResearchFooter from "@/reusable_sections/Footer";
import ProductPresentation from "./sections/ProductPresentation";
import HowItWorks from "./sections/HowItWorks";
import SalesBoost from "./sections/SalesBoost";
import TrustBadges from "./sections/TrustBadges";
export default function HomePage() {
  return <div>
      <PrintTeeMainHeader />
      <SurgicalCategoryBanner />
      <SalesBoost />
      <ProductPresentation />
      <InvestorTrustCertification />
      <FeaturedResearchPeptides />
      <WhyChooseFreshness />
      <HowItWorks />
      <JoinTheGrowerCircle />
      <TrustBadges />
      <ComplianceResearchFooter />
    </div>;
}